import React, { useState } from "react";
import moment from "moment";
import __ from "lodash";
import {validateEmail} from "../../../functions/EmailValidation";
import Alert from "../../../controls/Alert";
import {awbNumIsValid} from "../BookingHelperFunctions";

const checkEmailAddresses = (emailArray) => {
  for (let i=0; i<emailArray.length; i++) {
    if (!validateEmail(emailArray[i].trim()))
      return emailArray[i];
  }
  return "";
}

// const awbNumIsValid = (serial) => {
//   if (serial) {
//     const serialString = serial.toString();
//     if (serialString.length < 8)
//       return false;
//     const lastDigit = serialString[7];
//     const checkValue = parseInt(serialString.substr(0,7));
//     const checkDigit = checkValue % 7;
//     if (parseInt(lastDigit) === checkDigit)
//       return true;
//   }
//   return false;
// }

const checkCurrencies = (currencyRates) => {
  for (const key of Object.keys(currencyRates)) {
    const rate = currencyRates[key];
    if (!rate || isNaN(rate) || rate[key] === 0)
    return false;
  }
  return true;
}


const checkDimensions = (dimensions) => {
  for (let d=0; d < dimensions.length; d++) {
    const dim = dimensions[d];
    if (!dim.pieces || isNaN(Number(dim.pieces)) || Number(dim.pieces) === 0) {
      return ("Not all 'Dimensions' lines contain a non-zero number of pieces");
    }
    if (!dim.weightPerPiece || isNaN(Number(dim.weightPerPiece)) || Number(dim.weightPerPiece) === 0) {
      return ("Not all 'Dimensions' lines contain a non-zero weight value");
    }
    if (!dim.volume || isNaN(Number(dim.volume)) || Number(dim.volume) === 0) {
      return ("Not all 'Dimensions' lines contain valid volume");
    }
  }

  return null;
}

const InternalSlrValidator = (props) => {
  const record = props.record;

  const [state, setState] = useState({
    error: null,
    errorMessage: null,
    id: null
  });

  const operatorName = __.startCase(__.toLower(process.env.REACT_APP_COMPANY)) || "Magma";

  let error = false;
  let errorMessage = "";
  let id = null;
  let skip = false;

  /*
    Examples of validators - the record will have a copy of the working data
  */
  // if (!record.*code*) {
  //   error = true;
  //   errorMessage = "Please select a valid code";
  // } else if (!moment(record.*date*).isValid()) {
  //   error = true;
  //   errorMessage = "Please enter a valid date";
  // } else if (moment(record.*date1*).isBefore(record.*date2*)) {
  //   error = true;
  //   errorMessage = "The '*date1 name*' date cannot be before the '*date2 name' date";
  // } else if (record.*number* <= 0) {
  //   error = true;
  //   errorMessage = "The *number field* must be greater than zero";
  // }

  if (!skip) {
    if (record.formMode === "SLR") {
      if (!error && !record.slrCompanyName) {
        error = true;
        errorMessage = "Company/Client name is required";
        id = "slrCompanyName";
      }
      if (!error && !record.slrContactName) {
        error = true;
        errorMessage = "Name of person submitting the request is required in the 'Requested By' field";
        id = "slrCompanyName";
      }
      if (!error && !record.slrContactEmail) {
        error = true;
        errorMessage = "Contact email address is required";
        id = "slrContactEmail";
      }
      let invalidEmail = record.slrContactEmail ? checkEmailAddresses(record.slrContactEmail.split(",")) : "";
      if (!error && invalidEmail !== "") {
        error = true;
        errorMessage = `'${invalidEmail}' is not a valid email address`;
        id = "slrContactEmail";
      }
    }
    if (!error && record.formMode !== "SLR" && (!record.awbPrefix || !record.awbSerial)) {
      error = true;
      errorMessage = "'Air Waybill Number' is required";
      id = "awbNumber";
    }
    if (!error && record.awbSerial && record.awbSerial.length < 8) {
      error = true;
      errorMessage = "Air Waybill 'Serial' must be 8 digits long";
      id = "awbNumber";
    }
    if (!error && record.awbSerial && !awbNumIsValid(record.awbSerial)) {
      error = true;
      errorMessage = "Air Waybill 'Serial' is invalid - incorrect check digit";
      id = "awbNumber";
    }


    // Special Loads
    if (record.formMode === "SLR" || record.bookingType === "SPECIAL LOAD") {
      if (!error && record.formMode === "SLR" && !record.specialLoad ) {
        error = true;
        errorMessage = "'Special Load' type is required";
        id = "specialLoad";
      }
      if (!error && record.formMode === "SLR" && !record.specialInformation ) {
        error = true;
        errorMessage = "Please provide further description of the 'Special Load' in the 'Special Information' field";
        id = "specialInformation";
      }
    }

    // Flight
    if (!error && !record.origin) {
      error = true;
      errorMessage = "Shipment 'Origin' airport of cargo is required";
      id = "origin";
    }
    if (!error && !record.charterOrigin) {
      error = true;
      errorMessage = `'${operatorName} Point of Departure Airport' is required`;
      id = "charterOrigin";
    }
    if (!error && !record.destination) {
      error = true;
      errorMessage = "'Destination' of cargo is required";
      id = "destination";
    }
    if (!error && record.charterOrigin && record.destination && record.charterOrigin === record.destination) {
      error = true;
      errorMessage = "Origin and Destination cannot be the same";
      id = "destination";
    }
    if (!error && !record.flightDate) {
      error = true;
      errorMessage = "'Requested Flight Date' is required - confirm date by typing or selecting from calendar";
      id = "flightDate";
    }
    const requestedFlightDate = moment(record.flightDate);
    if (!error && record.newBooking && record.flightDate && requestedFlightDate.isValid() && requestedFlightDate.isBefore(moment().add(1, "day").startOf('day'))) {
      error = true;
      errorMessage = "'Requested Flight Date' must be a future date - confirm date by typing or selecting from calendar";
      id = "flightDate";
    }
    if (!error && !record.originDelivery) {
      error = true;
      errorMessage = `'Expected Delivery at ${operatorName} Departure Point' is required - confirm date by typing or selecting from calendar`;
      id = "originDelivery";
    }
    if (!error && record.flightDate && record.originDelivery) {
      const flightDate = moment(record.flightDate);
      const delivery = moment(record.originDelivery);
      if (delivery.isAfter(flightDate)) {
        error = true;
        errorMessage = "Delivery of cargo cannot be after requested flight departure date";
        id = "originDelivery";
      }
    }

    // Shipment Declaration
    if (!error && record.formMode !== "SL" && !record.commodity ) {
      error = true;
      errorMessage = "'IATA Commodity Code' is required";
      id = "commodity";
    }
    if (!error && record.formMode === "SL" && !record.specialLoad ) {
      error = true;
      errorMessage = "'Special Load'  code is required";
      id = "specialLoad";
    }
    if (!error && record.formMode === "SL" && !record.specialInformation ) {
      error = true;
      errorMessage = "Please provide further description of the 'Special Load'";
      id = "specialInformation";
    }
    if (!error && record.dgr === "CAO" && (!record.unNumbers || !Array.isArray(record.unNumbers) || record.unNumbers.length < 1)) {
      error = true;
      errorMessage = "UN Number(s) must be provided for 'CAO' shipments";
      id = "unNumbers";
    }

    // T&C Acceptance
    if (!error && record.formMode !== "SLR" && !record.termsAccepted) {
      error = true;
      errorMessage = "Please accept the Terms & Conditions in order to submit the booking request";
      id = "termsAccepted";
    }

  }


  if (error !== state.error || errorMessage !== state.errorMessage) {
    setState({ ...state, error, errorMessage });
    if (props.onChange) {
      props.onChange({ error, errorMessage });
    }
  }

  return (
    <Alert open={error} severity="error" message={errorMessage} id={id}/>
  );
}

export default InternalSlrValidator;
